import { createSlice } from "@reduxjs/toolkit";

interface Example{
    nmbre: number;
}

const initialState: Example = {
    nmbre: 0
}

const exampleSlice = createSlice({
    name: 'example',
    initialState,
    reducers: {
        increment: (state) => {
            state.nmbre += 1;
        },
        decrement: (state) => {
            state.nmbre -= 1;
        },
        reset: (state) => {
            state.nmbre = 0;
        }
    }
});

export const { increment, decrement, reset } = exampleSlice.actions;
export default exampleSlice.reducer;